import React from 'react';
import { useAuth } from '../contexts/AuthContext';

// Not a login form: without a session the app goes to Connect by itself. This screen only
// exists for the cases that must NOT redirect (no globe-data account, service down, a logout
// that could not end the SSO session), each with the one way back in.
const Login = () => {
  const { login, loginError } = useAuth();

  if (!loginError) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          <div className="text-xl font-medium text-gray-700 dark:text-gray-200">Redirection vers Connect…</div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Identification</h1>

      <div className="mb-4 p-3 bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-200 rounded-md">
        {loginError}
      </div>

      <button
        className="bg-blue-500 hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        type="button"
        onClick={login}
      >
        Se connecter avec Connect
      </button>
    </div>
  );
};

export default Login;
